module.exports = __webpack_public_path__ + "media/images/RS37702_original_472x157-5b65e08521e2d328f6ceea3ed00c6ff6.png";